module.exports = __webpack_public_path__ + "img/workbench_icon7.2b009a93.svg";